import styled from "styled-components";

const SectionTitle = styled.div`
  font-size: 40px;
  font-weight: 400;
  line-height: 60px;
  margin-bottom: 32px;
  text-align: center;
`;
export default SectionTitle;
